import React from "react";
import { Theme } from "@astryxdesign/core/theme";
import { hubGoldTheme } from "./hubAstryxTheme";

/** Provider do Astryx no Hub — app é claro (sem toggle de tema). */
export default function AstryxTheme({ children }) {
  return (
    <Theme theme={hubGoldTheme} mode="light">
      {children}
    </Theme>
  );
}
